/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAccountsFilterConditions } from '../models/RestoreAccountsFilterConditions';
import { SortRestoreAccountsBy } from '../models/SortRestoreAccountsBy';

export class ListRestoreAccountsRequest {
  'filters'?: RestoreAccountsFilterConditions;
  'sorts'?: Array<SortRestoreAccountsBy>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "filters",
      "baseName": "filters",
      "type": "RestoreAccountsFilterConditions",
      "format": ""
    },
    {
      "name": "sorts",
      "baseName": "sorts",
      "type": "Array<SortRestoreAccountsBy>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListRestoreAccountsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

